import React from 'react';
import LandingPage from '../pages/LandingPage';
import HeartbeatsLanding from '../pages/HeartbeatsLanding';

/**
 * SmartLanding - Détecte le domaine et affiche la bonne landing page
 * 
 * LOGIQUE :
 * - heartbeats.fr (PRODUCTION uniquement) → HeartbeatsLanding
 * - TOUT LE RESTE (y compris preview) → LandingPage (La Petite Épicerie)
 * 
 * NOTE: Les environnements de preview affichent toujours La Petite Épicerie
 */
const SmartLanding = () => {
  const hostname = window.location.hostname.toLowerCase();
  
  console.log('[SmartLanding] Hostname détecté:', hostname);
  
  // 🎯 UNIQUEMENT les vrais domaines heartbeats.fr en PRODUCTION
  // Exclure les environnements de preview qui contiennent "preview" ou "emergentagent"
  const isPreviewEnvironment = 
    hostname.includes('preview') || 
    hostname.includes('emergentagent') ||
    hostname.includes('localhost');
  
  const isHeartbeatsDomain = !isPreviewEnvironment && (
    hostname === 'heartbeats.fr' || 
    hostname === 'www.heartbeats.fr' ||
    hostname.endsWith('.heartbeats.fr')
  );
  
  if (isHeartbeatsDomain) {
    console.log('[SmartLanding] → Affichage HeartbeatsLanding (production)');
    const handleGetStarted = () => {
      window.location.href = '/auth?mode=signup';
    };
    const handleLogin = () => {
      // Vérifier si déjà connecté
      const token = localStorage.getItem('heartbeats_token');
      if (token) {
        window.location.href = '/heartbeats-portal';
      } else {
        window.location.href = '/auth?mode=login';
      }
    };
    return <HeartbeatsLanding onGetStarted={handleGetStarted} onLogin={handleLogin} />;
  }
  
  // Page d'accueil La Petite Épicerie (preview + production LPE)
  console.log('[SmartLanding] → Affichage LandingPage (La Petite Épicerie)');
  return <LandingPage />;
};

export default SmartLanding;
